export const FormRow: React.FC = ({ children }) => (
  <div className="form-row">
    <div className="form-row-inner-layout">{children}</div>
  </div>
)
